/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { TechnologyDto } from '../models/technology-dto';

@Injectable({
  providedIn: 'root',
})
export class TechnologyRestControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getProjectTechnologyById
   */
  static readonly GetProjectTechnologyByIdPath = '/api/v1/technologies/{id}';

  /**
   * Provides TechnologyDto based on given Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProjectTechnologyById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProjectTechnologyById$Response(params: {
    id: number;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<TechnologyDto>> {

    const rb = new RequestBuilder(this.rootUrl, TechnologyRestControllerService.GetProjectTechnologyByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TechnologyDto>;
      })
    );
  }

  /**
   * Provides TechnologyDto based on given Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getProjectTechnologyById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProjectTechnologyById(params: {
    id: number;
  },
  context?: HttpContext

): Observable<TechnologyDto> {

    return this.getProjectTechnologyById$Response(params,context).pipe(
      map((r: StrictHttpResponse<TechnologyDto>) => r.body as TechnologyDto)
    );
  }

  /**
   * Path part for operation getAllTechnologies
   */
  static readonly GetAllTechnologiesPath = '/api/v1/technologies/all';

  /**
   * Provides the list of all available Technologies.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllTechnologies()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllTechnologies$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<TechnologyDto>>> {

    const rb = new RequestBuilder(this.rootUrl, TechnologyRestControllerService.GetAllTechnologiesPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<TechnologyDto>>;
      })
    );
  }

  /**
   * Provides the list of all available Technologies.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllTechnologies$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllTechnologies(params?: {
  },
  context?: HttpContext

): Observable<Array<TechnologyDto>> {

    return this.getAllTechnologies$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<TechnologyDto>>) => r.body as Array<TechnologyDto>)
    );
  }

  /**
   * Path part for operation deleteProjectTechnology
   */
  static readonly DeleteProjectTechnologyPath = '/api/v1/technologies/{projectId}';

  /**
   * Removes technology passed to the method from Projects based on the given projectId.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteProjectTechnology()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deleteProjectTechnology$Response(params: {
    projectId: number;
    body: TechnologyDto
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, TechnologyRestControllerService.DeleteProjectTechnologyPath, 'delete');
    if (params) {
      rb.path('projectId', params.projectId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Removes technology passed to the method from Projects based on the given projectId.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteProjectTechnology$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deleteProjectTechnology(params: {
    projectId: number;
    body: TechnologyDto
  },
  context?: HttpContext

): Observable<void> {

    return this.deleteProjectTechnology$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
